module.exports = __webpack_public_path__ + "img/sticker_15.93b9679a.svg";